const getContactMethods = state => state.contactMethods;
const getSelectedContactMethods = state => getContactMethods(state).selected;

const getEmailContactMethod = state => getSelectedContactMethods(state).email;
export const getEmailAddress = state => getEmailContactMethod(state).address || '';

const getPhoneContactMethod = state => getSelectedContactMethods(state).phone;
export const getPhoneNumber = state => getPhoneContactMethod(state).address || '';
export const getCountryCode = state => getPhoneContactMethod(state).countryCode || '';
export const getContactMethodErrors = state => getContactMethods(state).errors || [];
